<template>


            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title">Attendance Over Time</h3>
                </div>
                <div class="panel-body">

                    <form class="form-inline">
                        <div class="form-group form-group-sm">
                            <label for="filter_date" class="control-label">From Date:</label>
                            <datepicker placeholder="From Date" v-model="filterFromDate" dateformat="DD/MM/YYYY"></datepicker>
                        </div>
                        <div class="form-group form-group-sm">
                            <label for="filter_date" class="control-label">To Date:</label>
                            <datepicker placeholder="From Date" v-model="filterToDate" dateformat="DD/MM/YYYY"></datepicker>
                        </div>
                        <div class="form-group form-group-sm">
                            <div class="btn btn-primary" v-on:click="fetchAttendance()">Update</div>
                        </div>
                    </form>
                </div>
                    <template v-if="this.chartStatus">
                        <canvas width="1000" height="600" id="member-attendance-chart"></canvas>
                    </template>
                    <table class="table table-condensed table-responsive" style="width: 100%" v-if="this.tableStatus">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <template v-for="label in chartData.labels">
                                    <th>{{ shortUKDateFormat(label) }} </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="member in this.chartData.datasets">
                                <th>{{ member.label }}</th>
                                <template v-for="hours in member.data">
                                    <td>{{ hours }}</td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
            </div>


</template>

<script>

import Chart from 'chart.js';

export default {
        props: {
            member_id: Number,
            squad_id: Number,
            display_table: {
                type: Boolean,
                default: false
            },
            display_chart: { 
                type: Boolean,
                default: false
            },
            max_chart_datasets: {
                type: Number,
                default: 10
            },
            max_table_columns: {
                type: Number,
                default: 12
            }
        },
        data: function () {
            return {
                member_attendance_data: [],
                chart: null,
                chartOptions: null,
                chartData: null,
                chartContext: null,
                filterMemberId: this.member_id,
                filterSquadId: this.squad_id,
                filterFromDate: null,
                filterToDate: null,
                showTable: this.display_table,
                showChart: this.display_chart,
                maxChartDatasets: this.max_chart_datasets,
                maxTableColumns: this.max_table_columns
            }
        },
        computed: {
            attendanceFilters : function() {
                var filterString = 'filters='
                // 'training_date:2018-01-01~~2018-03-01&format=chartjs'
                // We always have a date range filter
                if (this.filterFromDate == null) {
                    this.filterFromDate = moment().subtract(12,'weeks').format('DD/MM/YYYY');
                }
                if (this.filterFromDate == null) {
                    this.filterFromDate = moment().format('DD/MM/YYYY');
                }
                filterString = filterString + 'training_date:' + moment(this.filterFromDate, 'DD/MM/YYYY').format('YYYY-MM-DD') + '~~' +  moment(this.filterToDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                if (this.filterMemberId != null) {
                    filterString = filterString + ',member_id:' + this.filterMemberId;
                }
                if (this.filterSquadId != null) {
                    filterString = filterString + ',squad_id:' + this.filterSquadId;
                }
                return filterString;
            },
            chartStatus: function() {
                return this.showChart && this.chartData != null && (this.chartData.datasets.length <= this.maxChartDatasets);
            },
            tableStatus: function() {
                return this.showTable && this.chartData != null && (this.chartData.labels.length <= this.maxTableColumns);
            }
        },
        methods: {
            fetchAttendance() {
                console.log('Fetching attendance');
                axios.get('/api/v1/member_training_sessions?format=chartjs&' + this.attendanceFilters).then((response) => {
                    // this.times = response.data;
                    console.log(response.data);
                    // this.member_attendance_data = response.data;
                    this.chartData = response.data;
                    // this.updateChartData(response.data);
                    // this.chartData = this.makeDataset(response.data);
                    this.displayChart();
                    // this.displayChart();
                });
            },
            createChart() {
                console.log('Creating chart');
                if (this.chartStatus) {
                    this.chartContext = document.getElementById("member-attendance-chart").getContext('2d');
                }
            },
            displayChart() {
                console.log('Displaying chart');
                // If we should display the chart but we haven't done previously, then we create it
                if (this.chartStatus && (this.chartContext == null)) {
                    this.createChart();
                }
                if (this.chart != null) {
                    this.chart.destroy();
                }
                // updateChartData(times);
                console.log(this.chartData);
                console.log(this.chartOptions);
                this.chart = new Chart(this.chartContext, {
                  type: 'bar',
                  data: this.chartData,
                  options: this.chartOptions
                });

            },
            updateChartData(member_attendance_data) {
                console.log('Updating attendance chart');
                console.log(member_attendance_data);

                var objDatasets = {};
                objDatasets.datasets = [];
                this.chartData = objDatasets;

                var memberChartData = [];
                var newDataset = null;

                for (var member_dataset of member_attendance_data) {

                    console.log('Member Dataset...');
                    console.log(member_dataset.label);
                    console.log(member_dataset);

                    for (var datapoint of member_dataset.data) {
                        console.log('datapoint...');
                        console.log(datapoint.x);
                        console.log(datapoint.y);
                        memberChartData.push ({
                            x: moment(datapoint.x, "DD/MM/YYYY"),
                            y: datapoint.y
                        });
                    }

                    newDataset = {
                            label: member_dataset.label,
                            data: memberChartData
                          };

                    console.log('New Dataset...');
                    console.log(newDataset);

                    objDatasets.datasets.push(newDataset);

                }
                this.chartData = objDatasets;



                // this.chart.data.datasets[0] = this.ChartData;
                // this.chart.update();
            },
            setInitialDateFilter() {
                console.log('setInitialDateFilters');
                this.filterFromDate = moment().subtract(12,'weeks').format('DD/MM/YYYY');
                this.filterToDate = moment().format('DD/MM/YYYY');
            },
            setChartOptions() {
                this.chartOptions = {
                  responsive:true,
                  legend: {
                    display: false,
                    position: 'top',
                    labels: {
                      boxWidth: 80,
                      fontColor: 'black'
                    }
                  },
                  scales: {
                    xAxes: [{
                        stacked: true,
                        barPercentage: 1,
                        categoryPercentage: 0.8
                    }],
                    yAxes: [{
                      stacked: true,
                      scaleLabel: {
                        display: true,
                        labelString: "Hours",
                        fontColor: "blue"
                      }
                    }]
                  }
                };
            },
            shortUKDateFormat(ukDate) {
                return moment(ukDate, 'DD/MM/YYYY').format('DD/MM');
            }

        
        },

    mounted() {
        this.setInitialDateFilter();
        this.createChart();
        this.setChartOptions();
        this.fetchAttendance();
    }
}
</script>